module.exports = __webpack_public_path__ + "img/coin.caaf091c.png";